import styled from 'styled-components'
import { Button } from '../UI/Button'

const StyledButton = styled(Button)`
  min-width: 80px;
  justify-content: center;
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 1px;
`

export default StyledButton
